var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNas0BT1Svg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "unknow",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.nas{fill:#040000;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "nas",
    d: "M50,130.3c0-1.1,0.9-2.1,2-2.1c1.1,0,2,0.9,2,2.1c0,1.1-0.9,2.1-2,2.1C50.9,132.4,50,131.5,50,130.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "nas",
    d: "M50,137.8c0-1.1,0.9-2.1,2-2.1c1.1,0,2,0.9,2,2.1c0,1.1-0.9,2.1-2,2.1C50.9,139.9,50,138.9,50,137.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "nas",
    d: "M50,145.1c0-1.1,0.9-2.1,2-2.1c1.1,0,2,0.9,2,2.1c0,1.1-0.9,2.1-2,2.1C50.9,147.2,50,146.2,50,145.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "nas",
    d: "M169.3,58.8C169.3,58.8,169.3,58.8,169.3,58.8c-0.4-1.1-1-2.1-1.7-3l-11.4-19.7c-2-3.5-5.8-5.7-9.8-5.7H54.2  c-3.9,0-7.7,2.1-9.7,5.5L32.6,55.5c-0.7,0.9-1.3,1.8-1.7,2.9c-0.1,0.2-0.2,0.3-0.2,0.5c-0.5,1.4-0.8,2.8-0.8,4.4l3,90.7  c0,6.3,4.6,11.4,10.2,11.4h4.9c-0.1,0.3-0.1,0.5-0.1,0.8v0c0,1.8,1.5,3.3,3.3,3.3h10.3c1.8,0,3.3-1.5,3.3-3.3v0c0-0.3,0-0.6-0.1-0.8  h69.8c-0.1,0.3-0.1,0.5-0.1,0.8v0c0,1.8,1.5,3.3,3.3,3.3h10.3c1.8,0,3.3-1.5,3.3-3.3v0c0-0.3,0-0.6-0.1-0.8h5.4  c5.6,0,10.2-5.1,10.2-11.3l3.2-90.9C170.1,61.7,169.8,60.2,169.3,58.8z M48.8,38.5c1.1-1.9,3.2-3.1,5.4-3.1h92.2  c2.3,0,4.4,1.2,5.5,3.2l7.7,13.3H40.7L48.8,38.5z M43.1,160.4c-2.9,0-5.2-2.9-5.2-6.5l-3-90.7c0-0.9,0.1-1.7,0.4-2.5l1.4-2.4  c0.9-0.9,2.1-1.5,3.3-1.5h29.1v103.6H43.1z M161.9,154c0,3.5-2.3,6.4-5.2,6.4H71.2V56.8h88.7c1.4,0,2.6,0.6,3.5,1.7l1.3,2.2  c0.3,0.7,0.4,1.5,0.4,2.4L161.9,154z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "nas",
    d: "M93.4,142.5c-0.6,0-1-0.4-1-1V91.1c0-0.6,0.4-1,1-1s1,0.4,1,1v50.4C94.4,142,93.9,142.5,93.4,142.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "nas",
    d: "M116.2,142.5c-0.6,0-1-0.4-1-1V91.1c0-0.6,0.4-1,1-1s1,0.4,1,1v50.4C117.2,142,116.8,142.5,116.2,142.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "nas",
    d: "M139.9,142.5c-0.6,0-1-0.4-1-1V91.1c0-0.6,0.4-1,1-1s1,0.4,1,1v50.4C140.9,142,140.5,142.5,139.9,142.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "nas",
    d: "M52.9,68.7h-4.8c-0.8,0-1.4,0.6-1.4,1.2l0.3,6.7c0,0.6,0.7,1.1,1.4,1.1h4.5c0.8,0,1.4-0.5,1.4-1.2v-6.7    C54.3,69.2,53.7,68.7,52.9,68.7z"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "nas",
    d: "M54.3,81.3v5.1c0,0.5-0.6,0.9-1.4,0.9H49c-0.8,0-1.4-0.4-1.4-0.9l-0.3-5.1c0-0.5,0.6-1,1.4-1h4.2  C53.7,80.3,54.3,80.8,54.3,81.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNas0BT1Svg);
export default __webpack_public_path__ + "static/media/ic_nas_0b_t1.svg.876863c91e3f2d8cf7606ced3b854b12.svg";
export { ForwardRef as ReactComponent };